/**
 * BookingLogMediaService
 * Service for managing booking log media attachments
 */
import { CrudService } from '../base/CrudService';
/**
 * Service for booking log media CRUD operations
 */
export class BookingLogMediaService extends CrudService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? BookingLogMediaService.DEFAULT_SERVICE_PATH,
            basePath: BookingLogMediaService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
}
BookingLogMediaService.DEFAULT_SERVICE_PATH = 'booking-management';
BookingLogMediaService.BASE_PATH = 'api/booking-log-media';
//# sourceMappingURL=BookingLogMediaService.js.map